// dependencies
import React from 'react'
import PropTypes from 'prop-types'

// components
import { NoTemplateEmailVerification } from '@components/accounts/EmailVerification/NoTemplateEmailVerification'
import SubscribeForm from './PredefinedComponents/SubscribeForm'
import ForgotPassword from './PredefinedComponents/ForgotPassword'

// assets

export const MODAL_ID = 'MODAL/GENERIC_MODAL'

const PREDEFINED_COMPONENTS = {
  subscription_form: SubscribeForm,
  forget_password: ForgotPassword,
  email_verification: NoTemplateEmailVerification,
}

export const GenericModal = ({ modalstate }) => {
  const PredefinedComponent = PREDEFINED_COMPONENTS[modalstate?.data?.PredefinedComponentModal]

  if (!PredefinedComponent) return null

  return <PredefinedComponent {...modalstate?.componentData} />
}

GenericModal.propTypes = {
  modalstate: PropTypes.object,
}
